// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Pt-z","tooltipWrapper":"Qt-z","icon":"Rt-z","tooltip":"St-z","content":"Tt-z"};